export default __webpack_public_path__ + "static/media/cz3.596a832d.svg";